import {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'

import {FallbackView} from '../pages/FallbackView'
import {isWalletV2Enabled} from '../modules/wallet/featureFlag'

// Lazy components MUST be declared at module scope. Declaring them inside the component
// creates a new component identity on every render, so React unmounts/remounts the whole
// page on each navigation → refetches all data + flashes skeletons (e.g. withdraw→cancel).
const Dashboard = lazy(() => import('../modules/dashboard/Dashboard'))
const Products = lazy(() => import('../modules/products/ProductPage'))
const NetworkPage = lazy(() => import('../modules/network/NetworkPage'))
const EwalletPage = lazy(() => import('../modules/ewallet/EwalletPage'))
const WalletPage = lazy(() => import('../modules/wallet/WalletRoute'))
const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
const SystemPage = lazy(() => import('../modules/system/SystemPage'))
const WebshopPage = lazy(() => import('../modules/webshop/WebshopPage'))
const PaymentPage = lazy(() => import('../modules/personalorder/PaymentPage'))
const StaffMembersPage = lazy(() => import('../modules/staffmember/StaffMemberPage'))
const CommissionPage = lazy(() => import('../modules/commission/CommissionPage'))
const TeamListPage = lazy(() => import('../modules/teamlist/TeamListPage'))
const OrderConfirmationPage = lazy(() => import('../modules/order/OrderConfirmationPage'))
const CallUsageOverviewPage = lazy(() => import('../modules/callUsage/CallUsageOverviewPage'))
const VimeoConfigPage = lazy(() => import('../modules/vimeo/VimeoConfigPage'))
const AuthPage = lazy(() =>
  import('../modules/auth/AuthPage').then((module) => ({
    default: module.AuthPage,
  }))
)

export function PrivateRoutes() {
  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path='/order/confirmation' component={OrderConfirmationPage} />
        <Route path='/dashboard' component={Dashboard} />
        <Route path='/products' component={Products} />
        <Route path='/network' component={NetworkPage} />
        <Route path='/ewallet' component={EwalletPage} />
        {isWalletV2Enabled() && <Route path='/wallet' component={WalletPage} />}
        <Route path='/account' component={AccountPage} />
        <Route path='/system' component={SystemPage} />
        <Route path='/video-automations' component={VimeoConfigPage} />
        <Route path='/webshop' component={WebshopPage} />
        <Route path='/personalorder' component={PaymentPage} />
        <Route path='/invoices' component={PaymentPage} />
        <Route path='/subscriptions' component={PaymentPage} />
        <Route path='/commission' component={CommissionPage} />
        <Route path='/staffmembers/' component={StaffMembersPage} />
        <Route path='/teamlist/' component={TeamListPage} />
        <Route path='/call-usage-overview' component={CallUsageOverviewPage} />

        <Route path='/auth/forgotpassword' component={AuthPage} />
        <Route path='/staff/forgotpassword' component={AuthPage} />
        <Route path='/auth/resetpassword' component={AuthPage} />
        <Route path='/staff/resetpassword' component={AuthPage} />

        <Redirect from='/auth' to='/dashboard' />
        <Redirect from='/staff' to='/dashboard' />
        <Redirect exact from='/' to='/dashboard' />

        <Redirect to='error/404' />
      </Switch>
    </Suspense>
  )
}
